import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SuccessFill = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zM8 13.85l-3-3 .7-.7 2.3 2.3 6.3-6.3.7.7-7 7z"></path>
      </g>
    </g>
  </SvgIcon>
);

export default SuccessFill;
